/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import {
    AclService,
    ClusterService,
    LbRbacService,
    ModuleService,
    NetworkingService,
    PortsService,
    PromptService,
    TimerService,
    UpdatesService,
    WizardControllerStateService,
    WizardService,
    WizardTemplateService,
    WizardUtilsService
} from './services';
import {
    AddCertComponent,
    AddEditCipherListComponent,
    AddEditHeaderComponent,
    AddEditRegionComponent,
    AddFormRowComponent,
    CheckboxComponent,
    CipherListComponent,
    ClientDetailsComponent,
    DisplayCodeComponent,
    DragNDropTableComponent,
    EditCertComponent,
    FallbackServerOptionsComponent,
    FloatingIPComponent,
    L7HeadersComponent,
    LbImageComponent,
    LicensePillComponent,
    LoggedInUserComponent,
    MenuFooterComponent,
    RegionDetailsComponent,
    RegionsComponent,
    SSLOffloadOptionsComponent,
    TemplateSelectorComponent,
    TimeSelectorComponent,
    WizardComponent
} from './components';
import {
    EnduranceRBACRolesApiService,
    FIPApiService,
    HaproxyStatsApiService,
    Layer4ApiService,
    Layer7ApiService,
    WafApiService
} from './http';
import { EnduranceResolverGuard } from './guards/endurance-resolver-guard.service';
import {
    GslbBackendComponent,
    GslbFrontendComponent,
    GslbRealServerComponent,
    RealServerTableComponent,
    TopologyComponent
} from './components/serviceComponents';
import { Layer7RealComponent } from './components/serviceComponents/l7Services/servicesReal/layer7-real.component';
import { MultiPortRangeValidationDirective, PathEndValidationDirective, PathValidationDirective } from './directives';
import { NgModule } from '@angular/core';
import { RegionsApiService } from './http/regions.api.service';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../core/shared.module';
import { SnmpConfigComponent, SnmpUserComponent } from '../pages/localConfiguration';

/**
 * Shared imports between pages.
 * Note: You must define a new dep. as an IMPORT/DECLARATION AND EXPORT it!
 */
@NgModule({
    imports: [
        SharedModule,
        RouterModule
    ],

    declarations: [
        AddCertComponent,
        AddEditCipherListComponent,
        AddEditHeaderComponent,
        AddEditRegionComponent,
        AddFormRowComponent,
        CheckboxComponent,
        CipherListComponent,
        ClientDetailsComponent,
        DisplayCodeComponent,
        DragNDropTableComponent,
        EditCertComponent,
        FallbackServerOptionsComponent,
        FloatingIPComponent,
        GslbFrontendComponent,
        L7HeadersComponent,
        LbImageComponent,
        LicensePillComponent,
        LoggedInUserComponent,
        GslbRealServerComponent,
        MenuFooterComponent,
        MultiPortRangeValidationDirective,
        PathEndValidationDirective,
        PathValidationDirective,
        GslbBackendComponent,
        RegionDetailsComponent,
        RegionsComponent,
        SSLOffloadOptionsComponent,
        SnmpConfigComponent,
        SnmpUserComponent,
        TemplateSelectorComponent,
        TimeSelectorComponent,
        TopologyComponent,
        WizardComponent,
        Layer7RealComponent,
        RealServerTableComponent
    ],
    providers: [
        AclService,
        ClusterService,
        EnduranceRBACRolesApiService,
        EnduranceResolverGuard,
        FIPApiService,
        HaproxyStatsApiService,
        Layer4ApiService,
        Layer7ApiService,
        LbRbacService,
        ModuleService,
        NetworkingService,
        PortsService,
        PromptService,
        RegionsApiService,
        TimerService,
        UpdatesService,
        WafApiService,
        WizardControllerStateService,
        WizardService,
        WizardTemplateService,
        WizardUtilsService
    ],
    exports: [
        CheckboxComponent,
        CipherListComponent,
        ClientDetailsComponent,
        DisplayCodeComponent,
        DragNDropTableComponent,
        FallbackServerOptionsComponent,
        FloatingIPComponent,
        L7HeadersComponent,
        LbImageComponent,
        LicensePillComponent,
        LoggedInUserComponent,
        MenuFooterComponent,
        MultiPortRangeValidationDirective,
        PathEndValidationDirective,
        PathEndValidationDirective,
        PathValidationDirective,
        SSLOffloadOptionsComponent,
        SharedModule,
        AddFormRowComponent,
        TemplateSelectorComponent,
        TimeSelectorComponent,
        WizardComponent,
        RegionsComponent,
        RealServerTableComponent
    ]
})

export class LoadbalancerSharedModule {
}
